import * as yup from 'yup';
import { versicherungsnehmerSchema as versicherungsnehmerSchemaBase } from '@/features/Sparten/shared/schema/kfz/versicherungsnehmerSchema/versicherungsnehmerSchema';
import { useNutzv2InputStore } from '@/features/Sparten/nutzv2/useInputStore';
import { ROLE, useClient } from '@/features/Clients';
import { getDifference } from '@/utils/dates/dates';

const validateFuehrerscheinDatum = (val: Date | null | undefined): boolean => {
  if (useNutzv2InputStore().versicherungsnehmer.isFirma) return true; // no need for companies

  if (val === null || val === undefined) return false;

  const { client } = useClient(ROLE.VERSICHERUNGSNEHMER);

  if (client.value === undefined) return false;

  if (client.value.data.geburtsdatum === null) return false;

  return getDifference(val, client.value.data.geburtsdatum, true) >= 18;
};

export const versicherungsnehmerSchema = versicherungsnehmerSchemaBase.concat(
  yup.object({
    fuehrerscheindatum: yup
      .date()
      .default(null)
      .nullable()
      .when(['isFirma', 'isFullAge'], {
        is: (val: boolean, isFullAge: boolean) => !val && !isFullAge,
        then: yup
          .date()
          .required()
          .test(
            'isOldEnough',
            'Fahrer muss beim Führerscheinerwerb mindestens 18 Jahre alt sein.',
            validateFuehrerscheinDatum,
          ),
      }),
  }),
);
